import React from "react";

const InfoIcon = ({ disabled = false }: { disabled?: boolean }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.33203 3.66927H7.66536V5.0026H6.33203V3.66927ZM6.33203 6.33594H7.66536V10.3359H6.33203V6.33594ZM6.9987 0.335938C3.3187 0.335938 0.332031 3.3226 0.332031 7.0026C0.332031 10.6826 3.3187 13.6693 6.9987 13.6693C10.6787 13.6693 13.6654 10.6826 13.6654 7.0026C13.6654 3.3226 10.6787 0.335938 6.9987 0.335938ZM6.9987 12.3359C4.0587 12.3359 1.66536 9.9426 1.66536 7.0026C1.66536 4.0626 4.0587 1.66927 6.9987 1.66927C9.9387 1.66927 12.332 4.0626 12.332 7.0026C12.332 9.9426 9.9387 12.3359 6.9987 12.3359Z"
        fill={disabled ? "#8F9295" : "var(--vc-violet)"}
      />
    </svg>
  );
};

export default InfoIcon;
